import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import WallpaperUsageHistory from '../../../domain/entities/WallpaperUsageHistory';

export default function reducer(
  state: {[key: number]: WallpaperUsageHistory} = {},
  action: AnyAction,
): {[key: number]: WallpaperUsageHistory} {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexWallpaperUsageHistoriesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: WallpaperUsageHistory},
            record: WallpaperUsageHistory,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.UpdateWallpaperUsageHistorySuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
